import { render } from "./LocationCreate.vue?vue&type=template&id=19e1b7f1"
import script from "./LocationCreate.vue?vue&type=script&lang=ts"
export * from "./LocationCreate.vue?vue&type=script&lang=ts"
script.render = render

export default script